import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { adminActions, userActions } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cleanInput } from "../../redux/helpers";
import { formatDate } from "../pages/reports/DeliveryReport";

export const FilterDelivery = ({
  date,
  start_date,
  setStartDate = () => { },
  end_date,
  setEndDate = () => { },
}) => {
  let params = useParams();

  let user = JSON.parse(localStorage.getItem("user"));
  let teamId = JSON.parse(localStorage.getItem("teamId"));
  const company_id = user?.data?.groups[teamId]?.company_id;
  const dispatch = useDispatch();
  // const remittedOrders = useSelector((state) => state.admin.remittedOrders);

  const [filters, setFilters] = useState({
    employee_id: "",
    courier_id: "",
  });

  const { employee_id, courier_id } = filters;

  // Memoize payload so it only changes when actual values change
  const payload = useMemo(() => ({
    company_id,
    start_date,
    end_date,
    employee_id,
    courier_id,
  }), [company_id, start_date, end_date, employee_id, courier_id]);

  useEffect(() => {
    const newPayload = { ...payload };
    cleanInput(newPayload);

    dispatch(
      adminActions.filterDeliveryReport(
        newPayload,
        params.page
      )
    );

    const noPagePayload = { ...payload };
    cleanInput(noPagePayload);
    dispatch(
      adminActions.filterRemittedOrdersNoPage(
        noPagePayload
      )
    );
  }, [payload, params.page, dispatch]);

  //   filtering the Staff by Date

  useEffect(() => {
    dispatch(userActions.getRider(company_id));
    dispatch(adminActions.getEmployees(company_id));
  }, [dispatch, company_id]);

  const allRiders = useSelector((state) => state.users.items);
  let myRiders = allRiders.data && allRiders.data.data;
  const allEmployees = useSelector((state) => state.admin.allEmployees);
  let myEmployees = allEmployees.data && allEmployees.data.data;

  const handlefilterValue = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <div className="separator-breadcrumb border-top" />
      <div className="date-picker-wrapper">
        <form>
          <div
            className="row d-flex justify-content-between"
            style={{ marginLeft: "10px" }}
          >
            <div className="allign col-md-6">
              <i
                className=" 
            i-Calendar-4"
                style={{ marginRight: "10px", marginTop: "10px" }}
              />
              <div className={"div-box" + (!start_date ? " is-invalid" : "")}>
                {/* <DatePicker
                  className="form-control"
                  selected={start_date}
                  onChange={(date) => setStartDate(date)}
                /> */}
                <DatePicker
                  className="form-control"
                  selected={start_date ? new Date(start_date) : null}
                  onChange={(date) => setStartDate(formatDate(date))}
                />
              </div>
              <span style={{ margin: "2px 2px" }}>-</span>
              <div className={"div-box " + (!end_date ? " is-invalid" : "")}>
                {/* <DatePicker
                  className="form-control"
                  selected={end_date}
                  onChange={(date) => setEndDate(date)}
                /> */}

                <DatePicker
                  className="form-control"
                  selected={end_date ? new Date(end_date) : null}
                  onChange={(date) => setEndDate(formatDate(date))}
                />
              </div>
            </div>
            <div className=" allign ml-2 emp-f">
              <select
                className="dropdown-btn  text-capitalize"
                name="employee_id"
                onChange={handlefilterValue}
              >
                <option value="">Employee: All</option>
                {myEmployees &&
                  myEmployees.map((employee, i) => (
                    <option value={employee.id} key={employee.id}>
                      {employee.employee_name}
                    </option>
                  ))}
              </select>
              <select
                className="dropdown-btn2 text-capitalize"
                name="courier_id"
                onChange={handlefilterValue}
              >
                <option value={''}>Rider: All</option>
                {myRiders &&
                  myRiders.map((rider, i) => (
                    <option value={rider.id} key={rider.id}>
                      {rider.courier_name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
